import { z } from 'zod';

// MergeTag schema
const MergeTagSchema = z.object({
  description: z.string(),
  // parameters: z.record(MergeTagParameterSchema).optional(),
});

const MergeTagsSchema = z.record(MergeTagSchema).readonly().optional();

// Assuming SerializedEditorState is an object, you can refine this to the actual structure if needed
const SerializedEditorStateSchema = z.record(z.any());

// EmailAttachment schema
const EmailAttachmentSchema = z.object({
  filename: z.string(),
  s3Key: z.string(),
});

// optional email array schema
const optionalEmailArray = () =>
  z.preprocess(
    (val) => {
      if (!Array.isArray(val)) return [];
      return val.filter((v) => v !== undefined);
    },
    z
      .array(z.string().email().or(z.literal('')))
      .optional()
      .transform((arr) => {
        const cleaned = arr?.filter((email) => email.trim() !== '') ?? [];
        return cleaned.length > 0 ? cleaned : undefined;
      }),
  );

// Email Options schema
const EmailOptionsSchema = z.object({
  reply_to: z.string().email().optional(),
  from_name: z.string().optional(),
  cc: optionalEmailArray(),
  bcc: optionalEmailArray(),
  headers: z.record(z.string()).optional(),
});

// EmailTemplate schema
export const EmailTemplateSchema = z
  .object({
    subject: z.string().min(1, 'Subject is required'),
    body: SerializedEditorStateSchema,
    merge_tags: MergeTagsSchema,
    attachments: z.array(EmailAttachmentSchema).optional(),
    options: EmailOptionsSchema.optional(),
  })
  .superRefine((data, ctx) => {
    const allowedTags = Object.keys(data.merge_tags ?? {});
    const fullText = JSON.stringify(data.body);
    // console.log(fullText);

    // const usedTags = Array.from(fullText.matchAll(/\{\{([\w.-]+)\}\}/g), (m) => m[1]);
    const usedTags = Array.from(fullText.matchAll(/\{\{(.*?)\}\}/g), (m) => m[1]);

    const invalidTags = usedTags.filter((tag) => !allowedTags.includes(tag));

    if (invalidTags.length > 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['body'],
        message: `Invalid merge tags used: ${invalidTags.join(', ')}`,
      });
    }
  });

// SmsTemplate schema for completeness
export const SmsTemplateSchema = z.object({
  body: z.string(),
  merge_tags: MergeTagsSchema,
});

// MessageTemplateSet schema
export const MessageTemplateSetSchema = z.object({
  email: EmailTemplateSchema.optional(),
  sms: SmsTemplateSchema.optional(),
});

export type EmailTemplateInputValues = z.input<typeof EmailTemplateSchema>;
export type EmailTemplateOutputValues = z.output<typeof EmailTemplateSchema>;

export type SmsTemplateInputValues = z.input<typeof SmsTemplateSchema>;
export type SmsTemplateOutputValues = z.output<typeof SmsTemplateSchema>;
